import { ITableFieldDictionary } from 'src/app/interfaces/field-settings.interface';
import { DataTypes } from 'src/shared/enums/data-type.enum';

const calibrationBonusTableDictionary: ITableFieldDictionary = {
    LevelBonus: { label: 'Level Bonus', type: DataTypes.INTEGER },
    HeightBonus: { label: 'Height Bonus', type: DataTypes.FLOAT },
    FLRBonus: { label: 'FAL/FLR Bonus', type: DataTypes.FLOAT },
    BrownfieldRedevelopment: { label: 'Brownfield', type: DataTypes.INTEGER },
    ParkingReductionBonus: { label: 'Parking Reduction Bonus', type: DataTypes.FLOAT }
};

export default calibrationBonusTableDictionary;
